import { Stack } from "@mui/material";
import { useAuthContext } from "../../auth/useAuthContext";
import LoginLayout from "../../layouts/login";
import AuthLoginForm from "./AuthLoginForm";
import logo from "../../assets/logo.png";

export default function Login() {
  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: "relative" }}>
        <center>
          <img width={300} src={logo} alt="logo" />
        </center>
      </Stack>
      <AuthLoginForm />
    </LoginLayout>
  );
}
